import { LayoutProps } from "../../components/LayoutWrapper";
import * as React from 'react';
import { HeaderMenu } from "../../components/HeaderMenu";
import { Button, Grid, Header, Icon, Input, Loader, Message, Modal, Responsive, Table } from "semantic-ui-react";
import { ResponsiveElement } from "../../components/ResponsiveElement";
import { Helpers } from "../../utils/helpers";
import axios from 'axios';
import { Link } from "react-router-dom";

interface SortimentListItem {
    unique_id: number;
    title: string;
    key: string;
    nav_key: string;
    sortiments_papinet_id: string;
}

interface SortimentListState {
    sortiments: SortimentListItem[];
    loaded: boolean;
    searchKeyword: string;
}

interface SortimentListProps extends LayoutProps{
}

export class SortimentList extends React.Component<SortimentListProps, SortimentListState> {
    constructor(props) {
        super(props);
        this.state = {
            sortiments: [],
            loaded: false,
            searchKeyword: ''
        }
    }

    fetchSortiments = () =>
    axios.get(`/api/sortiments`, {
        headers: {
            Authorization: Helpers.getSessionId(),
            ActiveType: this.props.getActiveType(),
        },
    })
    .then(response => {
        console.log("response, ", response.data.data);
            this.setState({
                loaded: true,
                sortiments: response.data.data || [],
            });
        })
        .catch(_error => {
        console.log("errOR");

            this.setState({ loaded: true });
            Helpers.showError("Neizdevās ielādēt sortimentus!");
        })

    componentDidMount() {
        console.log("mounted");
        this.fetchSortiments();
    }

    filterSortiments = () => this.state.searchKeyword.length > 0 ? this.state.sortiments.filter(this.filterCallback) : this.state.sortiments;

    filterCallback = (sortiment: SortimentListItem) =>
        Helpers.toLowercase(sortiment.title).indexOf(this.state.searchKeyword.toLowerCase()) > -1 ||
        Helpers.toLowercase(sortiment.key).indexOf(this.state.searchKeyword.toLowerCase()) > -1 ||
        Helpers.toLowercase(sortiment.nav_key).indexOf(this.state.searchKeyword.toLowerCase()) > -1 ||
        ((sortiment.sortiments_papinet_id != null) && Helpers.toLowercase(sortiment.sortiments_papinet_id).indexOf(this.state.searchKeyword.toLowerCase()) > -1);

    deleteSortiment = async (sortimentId: number) => {
        this.setState({
            loaded: false
        });

        try{
            await axios.delete(`/sortiments/${sortimentId}`, {
                headers: { Authorization: Helpers.getSessionId() }
            });
    
            Helpers.showSuccess('Sortiments veiksmīgi izdzēsts!');
        }catch(e){
            Helpers.showError('Kaut kas nogāja greizi!');
        }

        await this.fetchSortiments();
    }

    refreshSortiments = () => {
        this.setState({ loaded: false }, () => {
            this.fetchSortiments();
        });
    }

    searchSortiments = (keyword) => {
        this.setState({
            searchKeyword: keyword.target.value,
        });
    }

    render() {
        const deleteButton = (sortiment: SortimentListItem): JSX.Element =>
            <Modal
                trigger={<Icon link name='trash alternate outline' color="red"/>}
                header="Uzmanību!"
                content={`Vai patiešām vēlaties dzēst sortimentu "${sortiment.title}"?`}
                actions={['Nē!', { key: 'done', content: 'Dzēst sortimentu!', positive: false, onClick: () => this.deleteSortiment(sortiment.unique_id) }]}
            >
                
            </Modal>
        


        const renderSortiments = () => {
            if (this.filterSortiments().length === 0) {
                return <Message
                    error
                    header="Netika atrasts neviens sortiments!"
                    list={[
                        "Pārliecinaties, vai atlēgvārds ir ievadīts pareizi",
                    ]}
                />;
            }

            return <div>
                <Responsive maxWidth={Responsive.onlyMobile.maxWidth} className="full--width">
                    <h2 style={{ marginBottom: 15, marginTop: 20 }}>Sortimenti</h2>
                </Responsive>
                <Table celled size='large' unstackable>
                    <Table.Header>
                        <Table.HeaderCell>Nosaukums</Table.HeaderCell>
                        <Table.HeaderCell>key</Table.HeaderCell>
                        <Table.HeaderCell>Nav key</Table.HeaderCell>
                        <Table.HeaderCell>Papinet ID</Table.HeaderCell>
                        <Table.HeaderCell>Darbības</Table.HeaderCell>
                    </Table.Header>
                    <Table.Body>
                        {this.filterSortiments().map(sortiment => (
                            <Table.Row key={sortiment.unique_id} style={{ padding: 0 }}>
                                <Table.Cell>{sortiment.title}</Table.Cell>
                                <Table.Cell>{sortiment.key}</Table.Cell>
                                <Table.Cell>{sortiment.nav_key}</Table.Cell>
                                <Table.Cell>{sortiment.sortiments_papinet_id}</Table.Cell>
                                <Table.Cell>
                                    <Link to={`/sortiments/${sortiment.unique_id}`}><Icon link name='edit outline' /></Link>
                                    {deleteButton(sortiment)}
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                    
                </Table>
            </div>;
        };
        return (
            <div>
                <header style={{ background: "#fff" }}>
                    <div className="layout-wrapper">
                        <HeaderMenu { ...this.props }/>

                        <Responsive as={Grid}>
                            <Grid.Row style={{ paddingTop: 40, paddingBottom: 0 }}>
                                <Grid.Column mobile={16} computer={10}>
                                    <Header as="h1">Sortimenti</Header>
                                </Grid.Column>
                                <Grid.Column mobile={13} computer={5}>
                                    <ResponsiveElement mobileProps={{ size: "huge" }}>
                                        <Input fluid icon="search" placeholder="Meklēt sortimentus" onChange={this.searchSortiments}/>
                                    </ResponsiveElement>
                                </Grid.Column>
                                <Grid.Column mobile={3} computer={1}>
                                    <ResponsiveElement mobileProps={{ size: "huge", style: { marginLeft: 6 } }} desktopProps={{ style: { marginLeft: 15, width: "77%" } }}>
                                        <Button icon={true} onClick={this.refreshSortiments}>
                                            <Icon name="refresh"/>
                                        </Button>
                                    </ResponsiveElement>
                                </Grid.Column>
                            </Grid.Row>
                        </Responsive>
                    </div>
                </header>

                <div className="layout-wrapper">
                    <Button as={Link} to="/sortiment/create" icon labelPosition='right' style={{marginBottom: '15px'}}>
                        Izveidot jaunu sortimentu
                        <Icon name='plus' />
                    </Button>
                    {!this.state.loaded ? <Loader active size="large" inline="centered">Lūdzu uzgaidiet</Loader> : renderSortiments()}
                </div>
            </div>
        )
    }
}

